import axios, { AxiosResponse } from 'axios'; //npm install axios --save //npm install --save es6-promise For IE
import { Constant } from '@/helpers/constant';
import { Rest, RestHeader } from '@/helpers/rest';
import { Employer } from '@/models/employer';
import router from '@/router';


class EmployerService {
  axios;

  constructor() {
    this.axios = axios.create({});
  }
  public createEmployer(employer): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/employer/create-employer', employer,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }
  public updateEmployer(employer, id: number): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/employer/update-employer/' + id, employer,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {

          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }
  public updateEmployerPassword(data: any, id: number): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/employer/updateEmployerPassword/' + id, data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {

          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }
  public updateEmployerByAdmin(employer: Employer, id: number): Promise<AxiosResponse<any>> {
    employer.provider = Constant.ADMIN_PROVIDER;
    return this.axios.post(Constant.SERVER_URL + 'api/employerAdmin/update-employer/' + id, employer,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {

          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public submitQuery(employer: Employer, id: number): Promise<AxiosResponse<any>> {
    employer.provider = Constant.ADMIN_PROVIDER;
    return this.axios.post(Constant.SERVER_URL + 'api/employerAdmin/submitQuery/' + id, employer,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {

          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public checkEmailIDExists(email: string): Promise<AxiosResponse<any>> {
    let data = {
      "email": email,
      "provider": Constant.EMPLOYER_PROVIDER
    };
    return this.axios.post(Constant.SERVER_URL + 'api/employer/getEmployerByEmail', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {

          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public checkCompanyRegistrationNumberExists(company_register_number: string): Promise<AxiosResponse<any>> {
    let data = {
      "field": "company_register_number",
      "value": company_register_number,
      "provider": Constant.EMPLOYER_PROVIDER
    };
    return this.axios.post(Constant.SERVER_URL + 'api/employer/getEmployerByField', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {

          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public checkEmailIDExistsWithAuth(email: string): Promise<AxiosResponse<any>> {
    let data = {
      "email": email,
      "provider": Constant.EMPLOYER_PROVIDER
    };
    return this.axios.post(Constant.SERVER_URL + 'api/employer/getEmployerByEmailWithAuth', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {

          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public addSubEmployer(employer: Employer): Promise<AxiosResponse<any>> {
    employer.provider = Constant.EMPLOYER_PROVIDER;
    return this.axios.post(Constant.SERVER_URL + 'api/employer/createSubEmployer', employer,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }
      ).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {

          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getCurrentEmployer(credentials): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/employer/getCurrentEmployer', credentials,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {

          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Invalid Credentials!")
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public loginEmp(credentials): Promise<AxiosResponse<any>> {

    return this.axios.post(Constant.SERVER_URL + 'api/employer/login-employer', credentials,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }
      ).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {

          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Invalid Credentials!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getAllEmployers(): Promise<AxiosResponse<any>> {
    let data = {
      provider: Constant.EMPLOYER_PROVIDER
    };
    return this.axios.post(Constant.SERVER_URL + 'api/employer/employers', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {

          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getCandidatsBySkillSearch(data): Promise<AxiosResponse<any>> {

    return this.axios.post(Constant.SERVER_URL + 'api/employer/search-jobseeker', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {

          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public viewJobseeker(jobseekerId: number): Promise<AxiosResponse<any>> {
    let data = {
      provider: Constant.EMPLOYER_PROVIDER
    };

    return this.axios.post(Constant.SERVER_URL + 'api/jobseekerEmployer/showJobseeker/' + jobseekerId, data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {

          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getEmployerById(id: number, provider: string): Promise<AxiosResponse<any>> {
    let url = "";
    if (provider == Constant.EMPLOYER_PROVIDER) {
      url = "api/employer/show-employer/";
    }
    else {
      url = "api/employerAdmin/show-employer/";
    }
    let data = {
      provider: provider
    };

    return this.axios.post(Constant.SERVER_URL + url + id, data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {

          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getRecentJobseekers(data: any): Promise<AxiosResponse<any>> {

    return this.axios.post(Constant.SERVER_URL + 'api/jobseekerEmployer/allJobseekers', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {

          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getTotalCompaniesCountForHomePage(data: any): Promise<AxiosResponse<any>> {

    return this.axios.post(Constant.SERVER_URL + 'api/employerJobseeker/getTotalEmployerCountForHomePage', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {

          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getAllEmployersByStatus(data: any): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/employerJobseeker/getAllEmployersForHomePage', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {

          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }
  public resetPasswordMailForEmployer(data: any): Promise<AxiosResponse<any>> {
    let url = "";
    if(data.provider == Constant.EMPLOYER_PROVIDER)
      url = "api/employer/resetPasswordMailForEmployer";
    else if(data.provider == Constant.ADMIN_PROVIDER)
      url = "api/employerAdmin/resetPasswordMailForEmployer";
    return this.axios.post(Constant.SERVER_URL + url, data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {

          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }
  
  public getEmployerByField(value,field): Promise<AxiosResponse<any>> {
    let data ={
      "value":value,
      "field":field,
      "provider":Constant.EMPLOYER_PROVIDER
    }
    return this.axios.post(Constant.SERVER_URL + 'api/employer/getEmployerByField', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getHRUsers(data: any,id:number): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/employer/getEmployersByEmpId/'+id, data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public deleteEmployer(data: any,id:number): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/employerAdmin/deleteEmployer/'+id, data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getEmployerStatistics(data,id): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL +'api/employer/employerDashboardStatics/'+id, data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
           alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getEmployersOnInputSearch(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL +'api/employerAdmin/getEmployersOnInputSearch', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
           alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public saveCandidate(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/employer/saveCandidate', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {

          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Invalid Credentials!")
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getSaveCandidate(data: any): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/employer/getSaveCandidate', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {

          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public deleteSaveCandidate(data: any): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/employer/deleteSaveCandidate', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {

          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getAllSaveCandidates(data: any): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/employer/getAllSaveCandidate', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {

          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }
  public updateEmployerStatus(data: any): Promise<AxiosResponse<any>> {
    let url = "";
    if(data.provider == Constant.ADMIN_PROVIDER){
      url = "api/employerAdmin/";
    }
    else if(data.provider == Constant.EMPLOYER_PROVIDER){
      url = "api/employer/";
    }
    return this.axios.post(Constant.SERVER_URL +url+'updateEmployerStatus', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {

          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }
  public inviteCandidateForJob(data: any): Promise<AxiosResponse<any>> {
    let url = "";
    if(data.provider == Constant.ADMIN_PROVIDER){
      url = "api/jobseekerAdmin/";
    }
    else if(data.provider == Constant.EMPLOYER_PROVIDER){
      url = "api/jobseekerEmployer/";
    }
    return this.axios.post(Constant.SERVER_URL +url+'inviteJobseekerForJobs', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {

          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getEmployersByAppliedJob(data: any): Promise<AxiosResponse<any>> { 
    return this.axios.post(Constant.SERVER_URL + 'api/employerJobseeker/getEmployersByAppliedJob', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getCompanies(data: any): Promise<AxiosResponse<any>> { 
    return this.axios.post(Constant.SERVER_URL + 'api/employerJobseeker/getEmployerCompanies', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getAdList(data: any): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/employer/listAds', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getAllEmpAdList(data: any): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/employerAdmin/listAllEmployerAds', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public addEmployerAds(data: any): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/employer/addEmployerAds', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public updateAdStatus(data: any): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/employerAdmin/updateAdStatus', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
}
export default new EmployerService();
